<template>
    <div class="filter-wrap">
            <div class="filter-info">
                Mostrando {{ items.length }} resultados para {{ screenName }} <!-- PAGINATION NOMENCLATURE -->
            </div>
            <div class="filter-sort-wrap">
                <span class="order-by-text">Ordenar por</span>
                <select class="available-sorting-list" @change="resort">
                    <option value="1" selected>Precio - Bajo a Alto</option>
                    <option value="2">Precio - Alto a Bajo</option>
                </select>
            </div>
        </div>
</template>

<script>
export default {
    name: 'sorter',
    props: {
        items: Array,
        screenName: String
    },
    methods: {
        resort: function (ev) {
            this.$emit('sortingcommand', ev.target.value);
        }
    }
}
</script>

<style scoped>
    .filter-wrap {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        font-size: 13px;
    }

    span.order-by-text {
        margin-right: 15px;
    }

    select.available-sorting-list {
        font-size: 13px;
        border: 0;
        background-color: #FAFAFA;
    }
</style>


// WEBPACK FOOTER //
// sorter.vue?93b3388a